import {FC, useMemo, useState} from "react";
import SecondaryButton from "~src/shared/buttons/basicButtons/SecondaryButton.sc";
import SvgIcon, {SvgIconName} from "~src/shared/SvgIcon";
import {useTranslation} from "react-i18next";
import logger from "~src/services/logger/LlsLogger";

interface Props {
  labelKey: string;
  filename: string;
  icon: SvgIconName;
  url: string;
  method?: 'GET'|'POST';
}

enum ExportState {
  initial, downloading, done, failed
}

export const AuthorizedDownload: FC<Props> = ({filename, icon, labelKey, method = 'GET', url}: Props) => {
  const { t } = useTranslation();

  const [exportState, setExportState] = useState(ExportState.initial);
  const stateIcon = useMemo(() => {
    switch(exportState) {
      case ExportState.done: return 'iconCheckFancy';
      case ExportState.failed: return 'iconCrossInCircle';
      case ExportState.downloading: return 'iconFileDown';
      default: return 'iconEmpty';
    }
  }, [exportState]);

  const getExport = () => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('jwt')}`);
    xhr.responseType = 'blob';
    xhr.onerror = () => {
      setExportState(ExportState.failed);
    };
    xhr.onabort = () => {
      setExportState(ExportState.initial);
    };
    xhr.onload = function (/*e: ProgressEvent<EventTarget>*/) {
      if (this.status >= 200 && this.status < 400) {
        setExportState(ExportState.done);
        const blob = new Blob([this.response], {type: 'text/csv'});
        const a = document.createElement("a");
        a.style.display = 'none';
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        logger.info('OTP user export succeeded');
      } else {
        setExportState(ExportState.failed);
        logger.error('OTP user export failed with ' + this.status);
      }
    };
    xhr.send();
    setExportState(ExportState.downloading);
  };

  return     <SecondaryButton data-translation={labelKey} onClick={getExport} disabled={exportState === ExportState.downloading}>
    <SvgIcon name={stateIcon}/>
    <SvgIcon width={25} viewBoxWidth={1000} name={icon} />
    &nbsp;{t(labelKey)}
  </SecondaryButton>
}
